import { Box, Flex, useColorModeValue } from "@chakra-ui/react";
import { useAuth } from "providers/auth.provider";
import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { BreadcrumbRender } from "./Breadcrumb/BreadcrumbRender";
import { BreadCrumbProvider } from "./Breadcrumb/Provider";
import { Footer } from "./Footer";
import { Header } from "./Header";

const LayoutDefaultContent = () => {
  const barClass = useColorModeValue("bar-light", "bar-dark");
  const { signedIn } = useAuth();
  const navigate = useNavigate();
  
  useEffect(() => {
    if (signedIn) {      
      navigate(`${window.location.pathname}${window.location.search}`);
    }
  }, [signedIn]);

  return (
    <Flex direction="column" flex={1} h="full" className={barClass}>
      <Header />
      <BreadcrumbRender />
      <Box h="full" overflowY="auto">
        <Outlet />
      </Box>
      <Footer />
    </Flex>
  );
};

export const LayoutDefault = () => {
  return (
    <BreadCrumbProvider>
      <LayoutDefaultContent />
    </BreadCrumbProvider>
  );
};
